import { render, staticRenderFns } from "./ReservedFilters.vue?vue&type=template&id=a2d41c2c&scoped=true&lang=pug"
import script from "./ReservedFilters.vue?vue&type=script&lang=js"
export * from "./ReservedFilters.vue?vue&type=script&lang=js"
import style0 from "./ReservedFilters.vue?vue&type=style&index=0&id=a2d41c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d41c2c",
  null
  
)

export default component.exports